<ng-container *ngIf="product$ | async as product">
  <div class="variant-generic-selector">
    <ng-container *ngFor="let category of categories">
      <label>
        <span>
          {{ getCategoryName(category) }}
        </span>

        <div
          *ngIf="category.hasImages; else noImages"
          role="list"
          [attr.aria-label]="category.name"
          class="image-variant-container"
        >
          <div *ngFor="let option of category.variantOptions" role="listitem">
            <button
              type="button"
              class="image-variant"
              [ngClass]="{ active: option?.code === product.code }"
              [attr.aria-label]="onAriaLabel(option, category.name) | async"
              (click)="changeVariant(option.code, option.value)"
              [cxFocus]="{ key: option.code }"
            >
              <cx-media [container]="option.image" role="img" />
            </button>
          </div>
        </div>
      </label>

      <ng-template #noImages>
        <div class="select-variant-container">
          <ng-select
            [clearable]="false"
            [searchable]="false"
            [items]="category.variantOptions"
            [(ngModel)]="selectedProductCode"
            (change)="changeVariant($event.code , $event.value)"
            [cxNgSelectA11y]="{
              ariaLabel:
                ('multiDimensionalSelector.variantThumbnailTitle' | cxTranslate
                  : {
                    category: category.name
                  }),
            }"
            bindValue="code"
            bindLabel="value">
          </ng-select>
          <div *ngIf="(category.name === 'Largo de la chapa' || category.name === 'Comprimento da chapa' || category.name === 'Length') && showLargoInput">
            <label for="largoDeseado">Por favor, indicar el largo deseado (mm):</label>
            <input
              type="number"
              class="form-control f-b"
              id="largoDeseado"
              [(ngModel)]="largoDeseado"
              placeholder="350"
              (keypress)="restrictLength($event)"
              (ngModelChange)="validateLargo()"
              [ngClass]="{'input-error': largoError}"
            />
            <span *ngIf="largoError" class="error-message">{{ largoError }}</span>
          </div>

        </div>
      </ng-template>
    </ng-container>
    <div>
      <app-gonvarri-chapa-quantity
        [product]="product"
        [packageWeigth]="packageWeight"
        [numberOfSheets]="numberOfSheets"
        [lenght]="largoDeseado"
        (updatePackageAndSheets)="updateValues($event)"
        (disableAddToCart)="updateIsDisabled($event)"
        (packProductFixedWeight)="setPackProductFixedWeight($event)"
      />
      <cx-add-to-cart
        [productCode]="passThrought(product.code)"
        [packageWeight]="packageWeight"
        [numberOfSheets]="numberOfSheets"
        [length]="largoDeseado"
        [packProductFixedWeight]="packProductFixedWeight"
        [isDisabled]="disableAddToCart"
        [isContract]="isContract"
        [product]="product"
        [showQuantity]="true"
        class="add-to-cart"
        [pickupStore]=""
        [options]="{
          isSaveForLater: false,
          optionalBtn: false,
          displayAddToCart: true,
          addToCartString: 'addToCart.addToCart' | cxTranslate
        }"
        [showAddToCart]="largoDeseado < 350"
      />
    </div>
  </div>
</ng-container>
